
/*eslint-disable no-unused-vars*/
import React from 'react';
/*eslint-enable no-unused-vars*/

export const SuccessError = (props) => {
  let { text, error} = props;
  return (
    <div className="row animated fadeInDown">
      <div className="col-md-6 col-md-offset-3">
        <br/>
        <br/>
        <h1 className="text-center" >
          {error ? "Error !" : "Success !"}
        </h1>
        <span className="alerticon text-center" >
          {error ?
            <i style={{
              color: " #eca1a6",
              display: "block",
              margin: "0 auto"
            }} className="fa fa-exclamation-circle fa-3x" aria-hidden="true"></i>
            :
            <i style={{
              color: "#b5e7a0",
              display: "block",
              margin: "0 auto"
            }} className="fa fa-check-circle-o fa-3x" aria-hidden="true"></i>
          }
        </span>
        <br/>
        <h5 className="text-center" >{text}</h5>
      </div>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/ResetPassword/SuccessError.js